import { useMutation, useQueryClient } from "@tanstack/react-query";
import { muteChat, unmuteChat } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

interface MuteChatPayload {
  chatId: number;
  muted: boolean;
}

export const useMuteChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ chatId, muted }: MuteChatPayload) =>
      muted ? muteChat(chatId) : unmuteChat(chatId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.Chats],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
